import { CheckIcon, TimeIcon } from '@braskai/icons';

import { TranslationKey, useInterfaceLanguage } from '@/shared/i18n';

import { SFeature, SFeatureList, SMinutes } from '../styled';

type PaywallMinutesProps = {
  label: string;
  isEnterprise?: boolean;
};

export const PaywallMinutes = ({ label, isEnterprise = false }: PaywallMinutesProps) => (
  <SMinutes $isEnterprise={isEnterprise}>
    <TimeIcon height={16} width={16} aria-hidden />
    {label}
  </SMinutes>
);

type PaywallFeatureListProps = {
  featureKeys: TranslationKey[];
  isCompact: boolean;
};

export const PaywallFeatureList = ({ featureKeys, isCompact }: PaywallFeatureListProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <SFeatureList $isCompact={isCompact}>
      {featureKeys.map((key) => (
        <SFeature key={key}>
          <CheckIcon aria-hidden />
          {t(key)}
        </SFeature>
      ))}
    </SFeatureList>
  );
};
